export default "__VITE_ASSET__CD7LPcVD__"